import BaseProxy from "../../../base-proxy";

/**
 * @class AmendCompanyShareStructureProxy
 * @description Amend Company Share Structure Request
 * @author Angelica Payawal
 * @version 1.0
 * @since May 18, 2021
 */
export default {
  /**
   * @async
   * @function start
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async start(input = {}) {
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/v2/sleek-workflow/amend-company-share-structure/start`;
    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },
};
